import react from 'react'

const PlayBack = () => {
    return (
        <div className='w-50 h-8 shrink hidden'>
            <div  className='w-full border border-gray-300 rounded-lg p-2 h-full shrink  '>

            </div>
        </div>
    )
}

export default PlayBack;